import { SpecialFieldUrls, SpecialFieldUrlTypeMap } from 'FormsUI/constants/SpecialFieldUrls';
const getIsSpecialFieldSelected = specialFieldType => ({
  selectedFormItemType,
  selectedFormItemReference
}) => {
  return selectedFormItemType && selectedFormItemType === SpecialFieldUrlTypeMap[specialFieldType] || selectedFormItemReference === specialFieldType;
};
export const isSubmitSelected = getIsSpecialFieldSelected(SpecialFieldUrls.SUBMIT);
export const isLegalConsentSelected = getIsSpecialFieldSelected(SpecialFieldUrls.LEGAL_CONSENT);
export const isCaptchaSelected = getIsSpecialFieldSelected(SpecialFieldUrls.CAPTCHA);